import axios from "axios";
import { apiOrigin } from "./apiBase";

export const API = `${apiOrigin}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export async function submitWaitlist(payload) {
    const { data } = await api.post("/waitlist", payload);
    return data;
}

export async function submitContact(payload) {
    const { data } = await api.post("/contact", payload);
    return data;
}

export async function trackBookDemoClick(payload) {
    try {
        const { data } = await api.post("/track/book-demo", payload);
        return data;
    } catch {
        // Never block the user's navigation on tracking failure
        return null;
    }
}

export async function getWaitlistStats() {
    const { data } = await api.get("/waitlist/stats");
    return data;
}

export async function getReferralCount(code) {
    const { data } = await api.get(`/waitlist/referral/${code}`);
    return data;
}

export async function validateReferralCode(code) {
    const clean = (code || "").trim();
    if (!clean) return { valid: false };
    try {
        const { data } = await api.get(`/waitlist/validate-ref/${encodeURIComponent(clean)}`);
        return data;
    } catch {
        return { valid: false };
    }
}

export async function listUpdates({ category, limit } = {}) {
    const params = {};
    if (category) params.category = category;
    if (limit) params.limit = limit;
    const { data } = await api.get("/updates", { params });
    return data;
}

export async function getUpdate(slug) {
    const { data } = await api.get(`/updates/${slug}`);
    return data;
}
